import { toast } from 'react-toastify'

import ImageValidation from 'utils/validation/images'
import { imageErrorMessages } from 'utils/validation/images'

export const createImageFormData = (
  image,
  productSku,
  orgName,
  folder,
  imageType
) => {
  const formData = new FormData()
  formData.append('image', image)
  formData.append('product_sku', productSku)
  formData.append('folder', folder)
  formData.append('organization_name', orgName)
  formData.append('image_type', imageType)
  return formData
}

export const createRevenueCenterImageFormData = (
  image,
  uuid,
  orgName
) => {
  const formData = new FormData()
  formData.append('image', image)
  formData.append('uuid', uuid)
  formData.append('organization_name', orgName)
  formData.append('folder', 'stand')
  formData.append('image_type', 'tout')
  return formData
}

export const createMenuImageFormData = (image, uuid, orgName) => {
  const formData = new FormData()
  formData.append('image', image)
  formData.append('uuid', uuid)
  formData.append('organization_name', orgName)
  formData.append('folder', 'stand_menu')
  formData.append('image_type', 'tout')
  return formData
}

export const submitImage = (event, file, setFile) => {
  event.preventDefault()
  if (file) {
    const imageValidation = ImageValidation.validateImage(file)

    if (imageValidation.hasError) {
      toast.warning(imageValidation.message)
      return
    }

    setFile(file)
  } else {
    toast.error(imageErrorMessages.get('imageEror'))
  }
}
